<footer class="footer text-center py-16 row-gap-8" fxLayout="column" fxLayoutAlign="start center">
  <span>
    In a psychiatric or medical emergency, call
    <a class="link blend" style="color: white; text-decoration: underline"
       href="tel:911">911</a>
    or go to the nearest emergency department.
  </span>
  <span>
    To reach the Suicide and Crisis Lifeline, call or text
    <a class="link blend" style="color: white; text-decoration: underline"
       href="tel:988">988</a>.
  </span>
</footer>